// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__PdgtS","vLegacy":"SelectSecondary_vLegacy__1UUgd","error":"SelectSecondary_error__3A3pg","disabled":"SelectSecondary_disabled__19O4u"};